import clsx from "clsx";
import st from "@/styles/UserSidebar.module.scss";
import WarningIcon2 from "@/svg/WarningIcon2.tsx";
import PromoIcon from "@/svg/PromoIcon.tsx";
import NotificationInterface from "@/types_and_interfaces/notification_interface.ts";
import CommonClass from "@/utils/common.ts";
import {useTranslation} from "react-i18next";
import CloseBtn from "@/ui/CloseButton.tsx";
import {useEffect, useState} from "react";
import DashboardClass from "@/utils/dashboard_class.ts";
import Button from "@/ui/Button.tsx";
import {useAtom} from "jotai";
import {profile} from "@/atoms/profile.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";


interface Props {
    obj:NotificationInterface
    on_click():void
    in_sidebar?:boolean,
    kyc_check?:boolean
}

const SystemNotificationComponent:React.FC<Props> = ({obj, on_click, in_sidebar, kyc_check}) => {

    const {t, i18n} = useTranslation()
    const [user] = useAtom(profile)

    const [hide, setHide] = useState<boolean>(false);
    const dayTime = CommonClass.displayDayTime(obj.created_at);

    useEffect(() => {
        if(!in_sidebar) {
            setTimeout(() => {
                setHide(true);
            }, 10000)
        }

    },[]);

    if (hide) return null;

    return  (
        <div
            className={clsx(
                st.notif_item,
                st[obj.info_type],
                !obj.is_read && st.unread,
                (obj.type === "loan_status_changed" && !obj.is_read) && st.loan_status_changed,
                (obj.type === "contract_signed_successful" && !obj.is_read) && st.contract_signed_successful,
                (obj.type === "cr_line_application_status_changed" && !obj.is_read) && st.contract_signed_successful,
                in_sidebar && st.in_sidebar
            )}
            onClick={on_click}
        >

            {obj.info_type === "danger" ? (
                <div className={st.left}>
                    <WarningIcon2/>
                </div>
            ) : (
                <div className={st.left}>
                    <PromoIcon/>
                </div>
            )}

            {/*{obj.info_type !== "danger" && (*/}

            {/*)}*/}


            <div className={st.right}>
                {obj.type === "admin_custom_notification" ? (
                    <>
                        <p>{obj.data[`title_${i18n.language}`]}</p>
                        <p>{obj.data[`body_${i18n.language}`]}</p>
                        </>
                    ) : (
                    <p>{t(obj.type) || "message"}</p>
                    )}

                {kyc_check && user?.identity_card_is_expiring_soon && (
                    <Button
                        onClick={() => {
                            eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.KYC + "/1")
                        }}
                    >
                        {t("kyc_verification")}
                    </Button>
                )}

                <span>
                    {dayTime}
                </span>

            </div>

            {!in_sidebar && (
                <CloseBtn
                    className={st.notif_close}
                    onClick={() => {
                        setHide(true)
                    }}
                />
            )}

        </div>
    )
}

export default SystemNotificationComponent